import { defineComponent as h, useModel as k, computed as c, openBlock as t, createElementBlock as i, createVNode as s, unref as u, withCtx as o, normalizeClass as f, Fragment as x, renderList as B, createBlock as m, resolveDynamicComponent as T, mergeProps as p, mergeModels as C } from "vue";
import V from "./index242.js";
import { TabGroup as w, TabList as z, TabPanels as L, TabPanel as P } from "./index243.js";
const K = {
  key: 1,
  class: "text-center text-gray-500"
}, E = /* @__PURE__ */ h({
  __name: "BaseTabs",
  props: /* @__PURE__ */ C({
    tabs: { default: () => [] },
    variant: { default: "underline" },
    size: { default: "lg" },
    underline: { type: Boolean, default: !1 },
    hasBackground: { type: Boolean, default: !1 },
    fullwidth: { type: Boolean, default: !1 },
    ariaLabel: { default: "탭 목록" }
  }, {
    modelValue: {
      default: ""
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const l = k(e, "modelValue"), r = e, b = c(() => r.tabs.findIndex((n) => n.key === l.value)), v = (n) => {
      const a = r.tabs[n];
      a && !a.disabled && (l.value = a.key);
    }, y = c(() => r.fullwidth ? "flex" : "flex items-center");
    return (n, a) => (t(), i("div", null, [
      s(u(w), {
        as: "div",
        selectedIndex: b.value,
        onChange: v
      }, {
        default: o(() => [
          s(u(z), {
            class: f(y.value),
            "aria-label": e.ariaLabel
          }, {
            default: o(() => [
              s(V, {
                tabs: e.tabs,
                size: e.size,
                variant: e.variant,
                underline: e.underline,
                hasBackground: e.hasBackground,
                fullwidth: e.fullwidth,
                selectedTabKey: l.value
              }, null, 8, ["tabs", "size", "variant", "underline", "hasBackground", "fullwidth", "selectedTabKey"])
            ]),
            _: 1
          }, 8, ["class", "aria-label"]),
          s(u(L), { class: "mt-2" }, {
            default: o(() => [
              (t(!0), i(x, null, B(e.tabs, (d) => (t(), m(u(P), {
                key: d.key,
                class: f(["bg-bg-bg-default rounded-xl p-3"]),
                role: "tabpanel",
                tabindex: 0
              }, {
                default: o(() => [
                  d.component ? (t(), m(T(d.component), p({
                    key: 0,
                    ref_for: !0
                  }, d.componentProps ?? {}, {
                    modelValue: l.value,
                    "onUpdate:modelValue": a[0] || (a[0] = (g) => l.value = g)
                  }), null, 16, ["modelValue"])) : (t(), i("div", K, "탭 컨텐츠가 없습니다."))
                ]),
                _: 2
              }, 1024))), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["selectedIndex"])
    ]));
  }
});
export {
  E as default
};
